/**
 * @typedef {Object} SignUp
 * @prop {string} urlUS
 * @prop {string} urlEU
 */

/**
 * @typedef {Object} PDGlobalObject
 * @prop {string} appVersion
 * @prop {SignUp?} signUp
 * @prop {string} googleAnalyticsId
 * @prop {string} segmentWriteKey
 * @prop {boolean} adBlock
 */

/** @typedef {import('@bugsnag/js').default} Bugsnag */

/** @typedef {Object} PDGlobals
 * @prop {PDGlobalObject} pd
 * @prop {Bugsnag} Bugsnag
 * @prop {any} analytics
 * @prop {any} ga
 * @prop {Function} onYouTubeIframeAPIReady
 * @prop {string} OnetrustActiveGroups
 * @prop {any} OneTrust
 * @prop {() => void} OptanonWrapper
 */

/**
 * @typedef {PDGlobals & Window & typeof globalThis} PDWindow
 */

export const win = /** @type {PDWindow} */ (window);
